import { SuggestionStatus } from './components/sug/Models';

export type Method = 'GET' | 'PUT' | 'PATCH' | 'DELETE' | 'POST';
export type EndpointUrl = string;
type IEndpoint = [EndpointUrl, Method];

export enum SearchOrderBy {
    Score,
    Date
}

export default class Endpoints {
    static readonly baseSuggestions: string = 'api/suggestions/';
    static readonly baseUser: string = 'api/user/';

    public static SUGGESTION_GETALL(exclude: number[] | null = null,
        orderBy: SearchOrderBy | null = null,
        status: SuggestionStatus | null = null,
        search: string | null = null): IEndpoint {
        let url = this.baseSuggestions;
        if (exclude != null || orderBy != null || status != null || search != null) {
            const params: string[] = [];
            if (exclude != null && exclude.length > 0) {
                params.push('exclude=' + exclude.join(','));
            }
            if (orderBy != null) {
                params.push('orderBy=' + orderBy);
            }
            if (status != null) {
                params.push('status=' + status);
            }
            if (search != null) {
                params.push('search=' + search);
            }

            if (params.length > 0) {
                url += '?' + params.join('&');
            }
        }
        return [url, 'GET'];
    }

    public static SUGGESTION_STATS(): IEndpoint {
        return [this.baseSuggestions + 'stats/', 'GET'];
    }

    public static SUGGESTION_GET(id: number): IEndpoint {
        return [this.baseSuggestions + id, 'GET'];
    }

    public static SUGGESTION_NEW(): IEndpoint {
        return [this.baseSuggestions, 'POST'];
    }

    public static SUGGESTION_EDIT(id: number): IEndpoint {
        return [this.baseSuggestions + id, 'PATCH'];
    }

    public static SUGGESTION_DELETE(id: number): IEndpoint {
        return [this.baseSuggestions + id, 'DELETE'];
    }

    public static SUGGESTION_REJECT(id: number): IEndpoint {
        return [this.baseSuggestions + 'reject/' + id, 'PATCH'];
    }

    public static SUGGESTION_COMPLETE(id: number): IEndpoint {
        return [this.baseSuggestions + 'complete/' + id, 'PATCH'];
    }

    public static SUGGESTION_REOPEN(id: number): IEndpoint {
        return [this.baseSuggestions + 'reopen/' + id, 'PATCH'];
    }

    public static SUGGESTION_UPVOTE(id: number): IEndpoint {
        return [this.baseSuggestions + 'upvote/' + id, 'POST'];
    }

    public static SUGGESTION_DOWNVOTE(id: number): IEndpoint {
        return [this.baseSuggestions + 'downvote/' + id, 'POST'];
    }

    public static SUGGESTION_COMMENT_ADD(suggestionId: number): IEndpoint {
        return [this.baseSuggestions + suggestionId + '/comment', 'POST'];
    }

    public static SUGGESTION_COMMENT_UPVOTE(id: number): IEndpoint {
        return [this.baseSuggestions + 'comment/upvote/' + id, 'POST'];
    }

    public static SUGGESTION_COMMENT_DOWNVOTE(id: number): IEndpoint {
        return [this.baseSuggestions + 'comment/downvote/' + id, 'POST'];
    }

    public static SUGGESTION_COMMENT_DELETE(suggestionId: number, commentId: number): IEndpoint {
        return [this.baseSuggestions + suggestionId + '/comment/' + commentId, 'DELETE'];
    }

    public static USER_GET(): IEndpoint {
        return [this.baseUser + 'me/', 'GET'];
    }

    public static USER_SET_BAN(userId: string, banState: boolean): IEndpoint {
        return [this.baseUser + `setban/${userId}/${banState}/`, 'PATCH'];
    }

    public static USER_MAKE_ADMIN(userId: string): IEndpoint {
        return [this.baseUser + `makeadmin/${userId}/`, 'PATCH'];
    }
}